module.exports = __webpack_public_path__ + "static/media/TuiTypes.46f60148.csv";